export const titles = {
    home: 'Inicio',
    contact: 'Contáctenos',
    events: 'Eventos',
    blog: 'Blog',

    // Auth
    register: 'Registrarse',
    login: 'Iniciar Sesión',
    restorePassword: ' Restablecer Contraseña',
    account: 'Cuenta',
    address: 'Mis direcciones',

    // Products
    order: 'Canasta',
    compare: 'Comparar productos',
    favorites: 'Favoritos',
    productNotFound: 'Producto no encontrado',
    category: 'Categorías',
    catalogue: 'Catalogo',
    promotions: 'Ofertas',
    results: 'Resultados',
    orders: 'Pedidos',
    ordersDetails: 'Detalle del pedido',

    // Checkout
    checkout: 'Checkout',
    confirmation: 'Confirmación',
    response: 'Respuesta',

    //headquarters
    headquartersMainPage: 'Nuestras Sedes'
};
